import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { Box, Divider, Link, Typography } from "@mui/material";

import { useUserDataFormatter } from "../../../User/hooks/useUserDataFormatter";

import { PostCardProps } from "../../types/types";
import { MidDotIcon, RepostIcon } from "../../assets/icons/post-icons";

import PostActions from "./PostActions";
import PostContent from "./PostContent";
import PostComments from "./PostComments";
import PostCardHeader from "./PostCardHeader";
import PostInteractions from "./PostInteractions";

const PostCard = ({ post, onClickOnMedia, isRepostedPost, isSharedPost, reposterUser }: PostCardProps) => {
  const { t } = useTranslation("feed", { keyPrefix: "postCard" });
  const [isPostCommentsDisplayed, setIsPostCommentsDisplayed] = useState(false);
  const toggleComments = () => setIsPostCommentsDisplayed((prevDisplay) => !prevDisplay);

  const { fullName, profileLink } = useUserDataFormatter(reposterUser);

  const isPostNotFound = !Boolean(post) || post.isDeleted;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        borderRadius: "8px",
        border: "1px solid #E7E7E7",
        background: "rgba(255, 255, 255, 0.90)",
      }}
    >
      {reposterUser && isRepostedPost && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            padding: "16px",
            borderBottom: "1px solid #E7E7E7",
          }}
        >
          <RepostIcon />
          <Link
            component={RouterLink}
            to={profileLink}
            sx={{
              textDecoration: "none",
              color: "var(--Dark---600, #707070)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "20px",
            }}
          >
            {fullName}
          </Link>
          <MidDotIcon />
          <Typography
            sx={{
              color: "var(--Dark---600, #707070)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "20px",
            }}
          >
            {t("repostedThisPost")}
          </Typography>
        </Box>
      )}

      {/* <PostInteractions name="John Doe" interaction="comment" /> */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {isPostNotFound ? (
          <Box>
            <Typography
              sx={{
                color: "var(--Dark---600, #707070)",
                fontFamily: "Montserrat",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "20px",
              }}
            >
              {t("noPostFound")}
            </Typography>
          </Box>
        ) : (
          <>
            <PostCardHeader post={post} isRepostedPost={isRepostedPost} />
            <PostContent post={post} onClickOnMedia={onClickOnMedia} />
          </>
        )}
        {!Boolean(isSharedPost) && <PostActions post={post} handleOnClickCommentsButton={toggleComments} />}
      </Box>
      {isPostCommentsDisplayed && (
        <>
          <Divider />
          <Box sx={{ padding: "16px", display: "flex", flexDirection: "column", gap: "16px" }}>
            <PostComments postId={post.id} />
          </Box>
        </>
      )}
    </Box>
  );
};

export default PostCard;
